var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1029,
    height: 1029,
    viewBox: "0 0 1029 1029",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M557.375 305.699C543.409 301.872 528.98 299.996 514.5 300.125C484.388 300.095 454.799 307.992 428.707 323.025C402.616 338.058 380.943 359.695 365.867 385.761C350.791 411.827 342.844 441.403 342.824 471.515C342.805 501.627 350.714 531.214 365.757 557.299C380.8 583.385 402.445 605.05 428.517 620.116C454.589 635.182 484.168 643.118 514.28 643.125C544.392 643.133 573.975 635.212 600.055 620.16C626.135 605.107 647.791 583.453 662.847 557.375",
    stroke: "black",
    strokeWidth: 66.6667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M728.875 385.875H900.375M814.625 300.125V471.625M514.5 643.125C461.171 642.858 409.656 662.478 370.016 698.154C330.376 733.83 305.457 783 300.125 836.062C363.311 877.916 437.423 900.235 513.214 900.235C589.004 900.235 663.116 877.916 726.303 836.062C721.015 783.441 696.463 734.63 657.365 699.015C618.268 663.4 567.386 643.495 514.5 643.125Z",
    stroke: "black",
    strokeWidth: 66.6667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M878.08 643.125C859.077 697.407 827.998 746.665 787.185 787.185C736.996 837.419 673.918 872.83 604.897 889.519C535.876 906.208 463.588 903.528 395.992 881.773C328.397 860.019 268.115 820.034 221.784 766.221C175.452 712.408 144.868 646.854 133.399 576.776C121.93 506.698 130.021 434.815 156.78 369.04C183.54 303.265 227.93 246.149 285.064 203.981C342.198 161.813 409.86 136.228 480.6 130.044C551.34 123.859 622.415 137.314 686 168.928",
    stroke: "black",
    strokeWidth: 66.6667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/add-user.8254f2294c0cd8cc35a35bebe4373e0a.svg";
export { ForwardRef as ReactComponent };